import type { MediaBlockAttrs } from './mediaBlock.types';
import { parseDataAttrs } from '@/shared/helpers/parseDataAttrs';

export const parseMediaBlockProps = (properties: Record<string, any>) =>
  parseDataAttrs<MediaBlockAttrs>(properties, {
    mediaType: 'audio',
    title: '',
    description: '',
    videoId: '',
    audioUrl: '',
    audioTitle: '',
  });
